<template>
<main class="container-1 assign-view">

    <div class="container-header">
        <Breadcrumb v-bind:links="routesBread"></Breadcrumb>
        <TabNav :links="routesNav" @action="onNavAction" />
        <p class="assign-view__hint">Los cambios se guardan al instante.</p>
    </div>

    <!-- Filtro compartido: aplica a ambos paneles -->
    <div class="assign-filters">
        <input id="search" v-model="inputMap" type="text" placeholder="Buscar mapa..." />
    </div>

    <div class="assign-panels">

        <!-- Panel: mapas disponibles -->
        <section class="apanel">
            <header class="apanel__head">
                <strong>Disponibles</strong>
                <span class="apanel__count">{{ availableMaps.length }}</span>
            </header>

            <div class="apanel__body">
                <div
                v-for="item in availableMaps"
                v-bind:key="item.id"
                class="arow">
                    <input type="checkbox" class="arow__check" :checked="isSelected(selAvailable, item.id)" v-on:change="toggleSelection(selAvailable, item.id)" :aria-label="'Seleccionar ' + item.name" />
                    <span class="arow__info">
                        <b class="arow__name">{{ item.name }}</b>
                        <small v-if="item.desc" class="arow__file">{{ item.desc }}</small>
                    </span>
                    <button class="btn btn-primary btn-row" v-on:click="assignMap(item)">+ Asignar</button>
                </div>

                <p v-if="!availableMaps.length" class="apanel__empty">No hay mapas disponibles.</p>
            </div>

            <footer class="apanel__foot apanel__foot--between">
                <label class="apanel__selall">
                    <input type="checkbox" :checked="allSelected(availableMaps, selAvailable)" v-on:change="toggleSelectAll(selAvailable, availableMaps)" />
                    Seleccionar todos
                </label>
                <button class="btn btn-primary btn-row" :disabled="!selectedItems(availableMaps, selAvailable).length" v-on:click="assignSelected()">Asignar seleccionados ({{ selectedItems(availableMaps, selAvailable).length }})</button>
            </footer>
        </section>

        <!-- Panel: mapas asignados -->
        <section class="apanel">
            <header class="apanel__head">
                <strong>Asignados al usuario</strong>
                <span class="apanel__count apanel__count--on">{{ assignedInView.length }}</span>
            </header>

            <div class="apanel__body">
                <div
                v-for="item in assignedInView"
                v-bind:key="item.id"
                class="arow">
                    <input type="checkbox" class="arow__check" :checked="isSelected(selAssigned, item.id)" v-on:change="toggleSelection(selAssigned, item.id)" :aria-label="'Seleccionar ' + item.name" />
                    <span class="arow__info">
                        <b class="arow__name">{{ item.name }}</b>
                        <small v-if="item.desc" class="arow__file">{{ item.desc }}</small>
                    </span>
                    <button class="btn btn-danger btn-row" v-on:click="unassignMap(item)">Quitar</button>
                </div>

                <p v-if="!assignedInView.length" class="apanel__empty">Aún no hay mapas asignados.</p>
            </div>

            <footer class="apanel__foot apanel__foot--between">
                <label class="apanel__selall">
                    <input type="checkbox" :checked="allSelected(assignedInView, selAssigned)" v-on:change="toggleSelectAll(selAssigned, assignedInView)" />
                    Seleccionar todos
                </label>
                <button class="btn btn-danger btn-row" :disabled="!selectedItems(assignedInView, selAssigned).length" v-on:click="unassignSelected()">Quitar seleccionados ({{ selectedItems(assignedInView, selAssigned).length }})</button>
            </footer>
        </section>

    </div>

    <UserDeleteModal
      v-if="showDeleteModal"
      :userId="$route.params.idUser"
      :userName="deleteModalUserName"
      @close="closeDeleteModal"
      @deleted="onUserDeleted"
    />

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import {assignSelection} from '@/components/mixin/assignSelection.js'
import { userDeleteModal } from '@/components/mixin/userDeleteModal.js'

export default{
    name: 'test',
    mixins: [assignSelection, userDeleteModal],
    data(){
        return{
            user: '',

            allMaps: [],
            assignedMaps: [],

            inputMap: ''
        }
    },
    components:{
        Breadcrumb,
        TabNav
    },
    computed: {
        routesNav: function(){
          return [
                {name:'Resumen' , path: '/usuarios/' + this.$route.params.idUser, exact: true},
                {name:'Editar usuario' , path: '/usuarios/' + this.$route.params.idUser + '/editar-usuario'},
                {name:'Asignar mapas' , path: '/usuarios/' + this.$route.params.idUser + '/asignar-mapas'},
                {name:'Crear contraseña temporal' , path: '/usuarios/' + this.$route.params.idUser + '/contrasena-temporal'},
                {name:'Historial de cambios' , path: '/usuarios/' + this.$route.params.idUser + '/historial-de-cambios'},
                {name:'Eliminar usuario' , action: 'delete'}
              ]
        },
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: (this.user.firstname || '') + " " + (this.user.lastname || ''), path: '/usuarios/' + this.$route.params.idUser},
              {name: 'Asignar mapas'}
              ]
        },
        // Mapas que coinciden con la búsqueda (nombre o descripción, blindado)
        matchedMaps: function() {
            var list = this.allMaps || [];
            var text = this.inputMap.trim().toLowerCase();
            if (!text) {
                return list;
            }
            return list.filter(function(map){
                var name = (map.name || '').toLowerCase();
                var desc = (map.desc || '').toLowerCase();
                return name.indexOf(text) !== -1 || desc.indexOf(text) !== -1;
            });
        },
        availableMaps: function() {
            return this.matchedMaps.filter(function(map){ return !map.isAssigned; });
        },
        assignedInView: function() {
            return this.matchedMaps.filter(function(map){ return map.isAssigned; });
        }
    },
    props: [],
    methods:{
        getUser: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser)
            .then(function (response) {
                that.user = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedMaps: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/maps') //Sin paginación
            .then(function (response) {
                that.assignedMaps = response.data || [];
                that.getAllMaps();
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAllMaps: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps') //Sin paginación
            .then(function (response) {
                that.allMaps = response.data || [];
                that.checkAlreadyAssignedMaps();
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        checkAlreadyAssignedMaps: function(){
            if(this.allMaps == null || this.assignedMaps == null) {
                return;
            }
            var assignedIndexInAll = [];
            for (let i = 0; i < this.assignedMaps.length; i++) {
                let index = this.allMaps.map(function(item){
                     return item.id;
                     }).indexOf(this.assignedMaps[i].id);
                assignedIndexInAll.push(index);
            }
            for (let i = 0; i < assignedIndexInAll.length; i++) {
                if(assignedIndexInAll[i] >= 0) {
                    this.allMaps[assignedIndexInAll[i]].isAssigned = true;
                }
            }
        },
        assignMap: function(map){
            var that = this;
            this.$http.post(this.$store.getters.backendurl + 'api/v1/maps/' + map.id + '/users/' + this.$route.params.idUser,
            {
                id_map: map.id,
                id_user: this.$route.params.idUser
            })
            .then(function (response) {
                that.getAssignedMaps();
            })
            .catch(function (error) {
                console.log(error);
                that.message = error.response.data.message;
            });
        },
        unassignMap: function(map){
            var that = this;
            this.$http.delete(this.$store.getters.backendurl + 'api/v1/maps/' + map.id + '/users/' + this.$route.params.idUser)
            .then(function (response) {
                that.getAssignedMaps();
            })
            .catch(function (error) {
                console.log(error);
                that.message = error.response.data.message;
            });
        },
        assignSelected: function(){
            var that = this;
            this.selectedItems(this.availableMaps, this.selAvailable).forEach(function(map){
                that.assignMap(map);
            });
            this.selAvailable.splice(0);
        },
        unassignSelected: function(){
            var that = this;
            this.selectedItems(this.assignedInView, this.selAssigned).forEach(function(map){
                that.unassignMap(map);
            });
            this.selAssigned.splice(0);
        }
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.layers? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getUser();
        this.getAssignedMaps();
    }
}
</script>

<style lang="scss" scoped>
.assign-view__hint {
    margin: 0.15rem 0 0;
    font-size: 0.78rem;
    color: var(--color-ghost);
}

.assign-filters {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin: 0.7rem 0 0.85rem;
}

.assign-filters input {
    width: 100%;
    padding: 0.5em 0.7em;

    border: 1px solid var(--color-line);
    border-radius: 7px;
    background: var(--color-white);
    color: var(--color-graphite);

    font-family: inherit;
    font-size: 0.9rem;
}

.assign-filters input:focus {
    outline: none;
    border-color: var(--color-steel);
    box-shadow: 0 0 0 3px rgba(59, 110, 148, 0.15);
}

.assign-panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.9rem;
    align-items: start;
}

.apanel {
    display: flex;
    flex-direction: column;

    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 10px;
    overflow: hidden;
}

.apanel__head {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    padding: 0.6rem 0.8rem;
    background: var(--color-mist);
    border-bottom: 1px solid var(--color-line);
}

.apanel__head strong {
    font-size: 0.9rem;
    color: var(--color-navy);
}

.apanel__count {
    margin-left: auto;
    min-width: 1.7em;
    padding: 0.05rem 0.5rem;

    border-radius: 999px;
    background: var(--color-steel);
    color: #fff;

    font-size: 0.72rem;
    font-weight: 700;
    text-align: center;
}

.apanel__count--on {
    background: var(--color-success);
}

.apanel__body {
    max-height: 52vh;
    overflow-y: auto;
}

.arow {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.5rem 0.7rem;
    transition: background-color 0.12s ease;
}

.arow + .arow {
    border-top: 1px solid var(--color-line);
}

.arow:hover {
    background: var(--color-mist);
}

.arow__info {
    flex: 1;
    min-width: 0;
}

.arow__name {
    display: block;
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--color-navy);
    word-break: break-word;
}

.arow__file {
    font-size: 0.72rem;
    color: var(--color-ghost);
}

.apanel__foot {
    display: flex;
    justify-content: flex-end;

    margin-top: auto;
    padding: 0.6rem 0.7rem;
    border-top: 1px solid var(--color-line);
}

.apanel__foot--between {
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.apanel__selall {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.76rem;
    color: var(--color-graphite);
    cursor: pointer;
    white-space: nowrap;
}

.apanel__selall input {
    accent-color: var(--color-steel);
    cursor: pointer;
}

.apanel__empty {
    margin: 0;
    padding: 2rem 1rem;
    text-align: center;
    color: var(--color-ghost);
    font-style: italic;
}

.arow__check {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    accent-color: var(--color-steel);
    cursor: pointer;
}

.btn-row {
    padding: 0.32em 0.8em;
    font-size: 0.8rem;
}

@media only screen and (max-width: 760px) {
    .assign-panels {
        grid-template-columns: 1fr;
    }
}
</style>
